import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  Category,
  EventResponseEvent,
} from '../../types/event-response.type';
import { NavigationService } from '../../services/navigation.service';
import { map, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Organization } from '../../types/organization.type';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingComponent {
  public events$: Observable<EventResponseEvent[]> = this.route.data.pipe(
    map((data) => data['events'])
  );

  public categories$: Observable<Category[]> = this.route.data.pipe(
    map((data) => data['categories'])
  );

  public organizations$: Observable<Organization[]> = this.route.data.pipe(
    map((data) => data['organizations'])
  );

  containerWidth: number;

  constructor(
    private navigationService: NavigationService,
    private route: ActivatedRoute
  ) {}

  get isMobile(): boolean {
    return this.containerWidth < 780;
  }

  get eventItemPerSlide(): number {
    if (this.containerWidth < 780) {
      return 1;
    }
    if (this.containerWidth < 1045) {
      return 2;
    }
    return 3;
  }

  get itemPerSlide(): number {
    if (this.containerWidth < 520) {
      return 1;
    }
    if (this.containerWidth < 780) {
      return 2;
    }
    if (this.containerWidth < 1045) {
      return 3;
    }
    return 4;
  }

  public goToEventPage({ event_id }: EventResponseEvent) {
    this.navigationService.goToEventPage(event_id);
  }
}
